"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2795,2428],{

/***/ 80651:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    height: 300,
    width: 300,
    link: {}
});


/***/ }),

/***/ 94351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GridImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/default-props.js
var default_props = __webpack_require__(80651);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-image/grid-image.scss.js

var StyledGridImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezk0g6e0"
})("display:flex;.image{width:100%;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-image/grid-image.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}






var GridImage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(GridImage, PureComponent);
    var _super = (0,_create_super/* default */.Z)(GridImage);
    function GridImage() {
        (0,_class_call_check/* default */.Z)(this, GridImage);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(GridImage, [
        {
            key: "renderPicture",
            value: function renderPicture() {
                var _props = this.props, src = _props.src, alt = _props.alt, isDecorative = _props.isDecorative, link = _props.link, imageStyle = _props.imageStyle;
                var href = link.href, isNewTab = link.isNewTab;
                var target = isNewTab ? "_blank" : "_self";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, {
                    src: src,
                    alt: alt,
                    isDecorative: isDecorative,
                    className: "image",
                    target: target,
                    href: href,
                    specificImageStyle: imageStyle
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, height = _props.height, width = _props.width, imagePosition = _props.imagePosition;
                var imagePositionStyles = (0,images_grid_service/* getImagePositionStyles */.y)(imagePosition);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGridImage, {
                    className: "grid-image",
                    style: _object_spread({
                        height: height,
                        width: width
                    }, imagePositionStyles),
                    children: this.renderPicture()
                });
            }
        }
    ]);
    return GridImage;
}(react.PureComponent);

GridImage.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 24055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mobile_tab_nav_button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tab-nav-button.scss.js



var StyledMobileTabNavButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "ewy7dq00"
})("font-size:0.875rem;font-weight:500;padding:7px 16px 9px;border-radius:20px;background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";white-space:nowrap;transition:background-color 0.2s ease-in-out,color 0.2s ease-in-out;&.selected{background-color:", colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}&.background-gray{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";&.selected{background-color:", colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME], ";}}&.crm-green{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.DARK_CRM_GREEN_COLOR_NAME], ";&.selected{background-color:", colors/* default */.Z[color_consts.DARK_CRM_GREEN_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}&.marketing-red{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.DARK_MARKETING_RED_COLOR_NAME], ";&.selected{background-color:", colors/* default */.Z[color_consts.DARK_MARKETING_RED_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}&.projects-orange{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.DARK_PROJECTS_ORANGE_COLOR_NAME], ";&.selected{background-color:", colors/* default */.Z[color_consts.DARK_PROJECTS_ORANGE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}&.dev-green{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.DARK_DEV_GREEN_COLOR_NAME], ";&.selected{background-color:", colors/* default */.Z[color_consts.DARK_DEV_GREEN_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}&.white{background-color:transparent;border:1px solid ", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";&.selected{background-color:rgba(255,255,255,0.2);border-color:rgba(255,255,255,0.2);color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}&.dev-lighter-tint-01{background-color:transparent;border:1px solid ", colors/* default */.Z[color_consts.BRAND_PRIMARY_GREEN], ";color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";&.selected{background-color:", colors/* default */.Z[color_consts.DEV_LIGHTER_TINT_01_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";border-color:", colors/* default */.Z[color_consts.DEV_LIGHTER_TINT_01_COLOR_NAME], ";}}&.crm-dark-tint-01{background-color:transparent;border:1px solid ", colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";&.selected{background-color:", colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";border-color:", colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";}}&.crm-darker-tint-02{background-color:transparent;border:1px solid ", colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";&.selected{background-color:", colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";border-color:", colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tab-nav-button.js



var MobileTabNavButton = function(props) {
    var label = props.label, selected = props.selected, theme = props.theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMobileTabNavButton, {
        className: classnames_default()("tab-nav-button", {
            selected: selected
        }, theme),
        children: label
    });
};
/* harmony default export */ var mobile_tab_nav_button = (MobileTabNavButton);


/***/ }),

/***/ 35998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mobile_tabs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./services/bigbrain-service.js + 1 modules
var bigbrain_service = __webpack_require__(95470);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tabs.scss.js


var StyledMobileTabs = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1bx2fs30"
})('*:focus{outline:none !important;}.carousel{.slick-slider.focus{.slick-list{.slick-track{padding:0;}}}}.mobile-tabs-navigation{overflow-x:auto;&::-webkit-scrollbar{display:none;}display:flex;gap:8px;padding-left:16px;.tab-nav-button-wrapper{display:flex;white-space:nowrap;}&::after{content:"";padding-right:16px;}}@media (min-width:', vp_sizes/* MOBILE_QUERY_MIN_WIDTH */.Lk, "){.carousel{.slick-slide{.side-by-side-text-and-asset{.side-by-side-content{.full-paragraph-component-wrapper{padding:0;}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tabs.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var VISIBILITY_SENSOR_OFFSET = -100;
var CAROUSEL_LEFT_SWIPE = "left";
var CAROUSEL_RIGHT_SWIPE = "right";
var MobileTabs = function(props) {
    var ref = (0,react.useState)(null), carouselRef = ref[0], setCarouselRef = ref[1];
    var ref1 = (0,react.useState)(false), isVisible = ref1[0], setIsVisible = ref1[1];
    var itemsRef = (0,react.useRef)([]);
    var tabs = props.tabs, selectedTab = props.selectedTab, setSelectedTab = props.setSelectedTab, navigationItemRenderer = props.navigationItemRenderer, carouselItemRenderer = props.carouselItemRenderer, wasComponentEverVisible = props.wasComponentEverVisible, setWasComponentEverVisible = props.setWasComponentEverVisible;
    var onVisibilityChange = function(isVisibleValue) {
        if (!wasComponentEverVisible && isVisibleValue) {
            setWasComponentEverVisible(true);
            if (selectedTab !== 0) {
                var _itemsRef_current_selectedTab, _itemsRef_current;
                itemsRef === null || itemsRef === void 0 ? void 0 : (_itemsRef_current = itemsRef.current) === null || _itemsRef_current === void 0 ? void 0 : (_itemsRef_current_selectedTab = _itemsRef_current[selectedTab]) === null || _itemsRef_current_selectedTab === void 0 ? void 0 : _itemsRef_current_selectedTab.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center"
                });
            }
        }
        setIsVisible(isVisibleValue);
    };
    var tabsWithVideoPlayerRefs = [];
    tabs.forEach(function(tab) {
        tabsWithVideoPlayerRefs.push(_object_spread_props(_object_spread({}, tab), {
            videoPlayerRef: (0,react.useRef)(null)
        }));
    });
    (0,react.useEffect)(function() {
        itemsRef.current = itemsRef.current.slice(0, tabsWithVideoPlayerRefs.length);
    }, [
        tabsWithVideoPlayerRefs
    ]);
    var onTabClicked = function(element, tab, index) {
        setSelectedTab(index);
        element.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
        });
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.TAB_CLICKED, {
            kind: tab.tabLabel,
            info1: index
        });
    };
    (0,react.useEffect)(function() {
        var _currentTab_videoPlayerRef;
        var currentTab = tabsWithVideoPlayerRefs[selectedTab];
        if (currentTab === null || currentTab === void 0 ? void 0 : (_currentTab_videoPlayerRef = currentTab.videoPlayerRef) === null || _currentTab_videoPlayerRef === void 0 ? void 0 : _currentTab_videoPlayerRef.current) {
            currentTab.videoPlayerRef.current.seekTo(0);
        }
        carouselRef === null || carouselRef === void 0 ? void 0 : carouselRef.slickGoTo(selectedTab);
    }, [
        selectedTab
    ]);
    var scrollToNavigationTabIfVisible = function(index) {
        if (isVisible) {
            var _itemsRef_current_index, _itemsRef_current;
            itemsRef === null || itemsRef === void 0 ? void 0 : (_itemsRef_current = itemsRef.current) === null || _itemsRef_current === void 0 ? void 0 : (_itemsRef_current_index = _itemsRef_current[index]) === null || _itemsRef_current_index === void 0 ? void 0 : _itemsRef_current_index.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    };
    var navItemRenderer = function(tab, index) {
        var isSelectedTab = selectedTab === index;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tab-nav-button-wrapper",
            ref: function(element) {
                return itemsRef.current[index] = element;
            },
            onClick: function(event) {
                return onTabClicked(event.target, tab, index);
            },
            children: navigationItemRenderer(tab, index, isSelectedTab)
        }, index);
    };
    var carouselProps = {
        items: tabsWithVideoPlayerRefs,
        itemRenderer: carouselItemRenderer,
        defaultIndex: wasComponentEverVisible ? 0 : selectedTab,
        slidesToShow: 1,
        autoplay: false,
        autoplaySpeed: -1,
        centerPadding: "5%",
        centerMode: false,
        infinite: false,
        fade: false,
        onRefSet: setCarouselRef
    };
    var onCarouselChange = function(current) {
        // fix selectedTab index in case of a glitch
        if (current !== selectedTab) {
            setSelectedTab(current);
            scrollToNavigationTabIfVisible(current);
        }
    };
    var onCarouselSwipe = function(direction) {
        var newSlide = selectedTab;
        if (direction === CAROUSEL_LEFT_SWIPE && selectedTab < tabs.length - 1) {
            newSlide = selectedTab + 1;
        }
        if (direction === CAROUSEL_RIGHT_SWIPE && selectedTab > 0) {
            newSlide = selectedTab - 1;
        }
        setSelectedTab(newSlide);
        scrollToNavigationTabIfVisible(selectedTab);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        offset: {
            bottom: VISIBILITY_SENSOR_OFFSET,
            top: VISIBILITY_SENSOR_OFFSET
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: !wasComponentEverVisible,
        scrollCheck: !wasComponentEverVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileTabs, {
            className: "mobile-tabs-component",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mobile-tabs-navigation",
                    children: tabsWithVideoPlayerRefs.map(function(tab, index) {
                        return navItemRenderer(tab, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "carousel-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, _object_spread_props(_object_spread({}, carouselProps), {
                        onChange: function(current) {
                            return onCarouselChange(current);
                        },
                        onSwipe: onCarouselSwipe
                    }))
                })
            ]
        })
    });
};
/* harmony default export */ var mobile_tabs = (MobileTabs);


/***/ }),

/***/ 72428:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    BASIC_HEADER_HEIGHT: 72,
    SECONDARY_HEADER_HEIGHT: 56,
    HEADER_CONTENT_HORIZONTAL_PADDING: 32,
    MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT: 52,
    MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT: 44,
    SIGNUP_POPUP_SCREEN_RIGHT_MARGIN: 16,
    SIGNUP_POPUP_SCREEN_WIDTH: 346,
    SIGNUP_POPUP_SCREEN_HEIGHT: 404,
    PRODUCTS_SWITCHER_SCREEN_WIDTH: 380,
    PRODUCTS_SWITCHER_NEW_USERS_SCREEN_HEIGHT: 480,
    PRODUCTS_SWITCHER_EXISTING_USERS_SCREEN_HEIGHT: 360,
    PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN: 32
});


/***/ }),

/***/ 93012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ use_cases_tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-desktop-component/use-cases-tabs-desktop-component.js + 3 modules
var use_cases_tabs_desktop_component = __webpack_require__(9306);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tab-nav-button.js + 1 modules
var mobile_tab_nav_button = __webpack_require__(24055);
// EXTERNAL MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tabs.js + 1 modules
var mobile_tabs = __webpack_require__(35998);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./node_modules/querystring/index.js
var querystring = __webpack_require__(17673);
// EXTERNAL MODULE: ./constants/query-params.js
var query_params = __webpack_require__(54224);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-mobile-component/use-cases-tabs-mobile-component.scss.js

var StyledUseCasesTabsMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1qps46c0"
})(".mobile-tabs-component{display:flex;flex-direction:column;gap:24px;}.asset-and-paragraphs-wrapper{display:flex;flex-direction:column;gap:16px;.full-paragraph{padding:0 32px;.title-wrapper{margin-bottom:4px;}}.use-case-product-banner{.use-case-product-banner-logo-and-text-wrapper{.use-case-product-banner-text{.full-paragraph{padding:0 8px;.paragraph-wrapper .paragraph-body{font-size:0.8125rem;line-height:21px;font-weight:400;text-align:center;}}}}}}");

// EXTERNAL MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/default-props.js
var default_props = __webpack_require__(29179);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-mobile-component/use-cases-tabs-mobile-component.js
function use_cases_tabs_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            use_cases_tabs_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












var UseCasesTabsMobileComponent = function(props) {
    var _router_asPath_split, _router_asPath;
    var ref = (0,react.useState)(false), wasComponentEverVisible = ref[0], setWasComponentEverVisible = ref[1];
    var buttonsColor = props.buttonsColor, tabs = props.tabs, router = props.router;
    var tabIds = tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab) {
        var _tab_tabId;
        return (_tab_tabId = tab === null || tab === void 0 ? void 0 : tab.tabId) !== null && _tab_tabId !== void 0 ? _tab_tabId : null;
    });
    var params = querystring.parse(router === null || router === void 0 ? void 0 : (_router_asPath = router.asPath) === null || _router_asPath === void 0 ? void 0 : (_router_asPath_split = _router_asPath.split("?")) === null || _router_asPath_split === void 0 ? void 0 : _router_asPath_split[1]);
    var activeTabId = params === null || params === void 0 ? void 0 : params[query_params.ACTIVE_TAB_ID];
    var getInitialSelectedTab = function() {
        if (tabIds === null || tabIds === void 0 ? void 0 : tabIds.includes(activeTabId)) {
            return tabIds === null || tabIds === void 0 ? void 0 : tabIds.indexOf(activeTabId);
        }
        return 0;
    };
    var ref1 = (0,react.useState)(getInitialSelectedTab), selectedTab = ref1[0], setSelectedTab = ref1[1];
    var navigationItemRenderer = function(tab, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_tab_nav_button/* default */.Z, {
            label: tab.tabLabel,
            selected: selectedTab === index,
            theme: buttonsColor
        });
    };
    var carouselItemRenderer = function(tab) {
        var ref = (tab === null || tab === void 0 ? void 0 : tab.tabContent) || {}, mobileAsset = ref.mobileAsset, images = ref.images, mobileTextAlign = ref.mobileTextAlign;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "asset-and-paragraphs-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread({}, mobileAsset)),
                images === null || images === void 0 ? void 0 : images.map(function(paragraph) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread_props(_object_spread({}, paragraph.fullParagraph), {
                        topic: {},
                        titleSize: sizes/* XS_L */.L4,
                        textSize: sizes.XS,
                        mobileTextAlign: mobileTextAlign
                    }));
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUseCasesTabsMobileComponent, {
        className: "use-cases-tabs-mobile-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_tabs/* default */.Z, _object_spread_props(_object_spread({}, props), {
            selectedTab: selectedTab,
            setSelectedTab: setSelectedTab,
            wasComponentEverVisible: wasComponentEverVisible,
            setWasComponentEverVisible: setWasComponentEverVisible,
            navigationItemRenderer: navigationItemRenderer,
            carouselItemRenderer: carouselItemRenderer
        }))
    });
};
UseCasesTabsMobileComponent.defaultProps = default_props/* default */.Z;
/* harmony default export */ var use_cases_tabs_mobile_component = ((0,router.withRouter)(UseCasesTabsMobileComponent));

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-component.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function use_cases_tabs_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function use_cases_tabs_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function use_cases_tabs_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        use_cases_tabs_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var COLOR_TO_CLASS_NAME = (0,_define_property/* default */.Z)({}, color_consts.DEV_LIGHTER_TINT_01, color_consts.DEV_LIGHTER_TINT_01_COLOR_NAME);
var UseCasesTabsComponent = function(_param) {
    var buttonsColor = _param.buttonsColor, rest = _object_without_properties(_param, [
        "buttonsColor"
    ]);
    var UseCasesTabsResponsiveComponent = (0,react.useMemo)(function() {
        return (0,responsive_hoc_component/* default */.Z)(use_cases_tabs_desktop_component/* default */.Z, use_cases_tabs_mobile_component);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UseCasesTabsResponsiveComponent, use_cases_tabs_component_object_spread_props(use_cases_tabs_component_object_spread({}, rest), {
        buttonsColor: COLOR_TO_CLASS_NAME[buttonsColor] || buttonsColor
    }));
};
/* harmony default export */ var use_cases_tabs_component = (UseCasesTabsComponent);
UseCasesTabsComponent.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 62587:
/***/ (function(module) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 12361:
/***/ (function(module) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 17673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



exports.decode = exports.parse = __webpack_require__(62587);
exports.encode = exports.stringify = __webpack_require__(12361);


/***/ })

}]);